import styles from "./banner.module.scss";
import { useEffect } from "react";
import lottie from "lottie-web";
import dataJson from "../../svg/home_banner.json";
import DownBtn from "../Public/DownBtn";

export default function DownLoadBanner() {
  useEffect(() => {
    const animation = lottie.loadAnimation({
      container: document.getElementById("ani"),
      renderer: "svg",
      loop: false,
      autoplay: false,
      animationData: dataJson,
      setDirection: 1,
    });
    setTimeout(() => {
      animation.play();
    }, 500);
    return () => {};
  }, []);
  return (
    <div className={styles.downLoadBanner}>
      <div className={styles.inner + " main flex-r"}>
        <div className={styles.left}>
          <h1 className="ani-fadeInUp">Free Calls & Texts for Everyone</h1>
          <p className="ani-fadeInUp">
            Call and Text Unlimitedly to Any Number
          </p>
          <h5 className="ani-fadeInUp">Free Download</h5>
          <DownBtn use="big" ani={true}></DownBtn>
        </div>
        <div className={styles.right}>
          <div className={styles.ani} id="ani">
          </div>
        </div>
      </div>
    </div>
  );
}
